import axios from '../apiEditor';
import qs from 'qs';

export default {
	getTags() {
		return axios.get().get(`/editor/tags`);
	}
};
